import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";

import { AppState } from "../../store";
import {
  ChatIconSize,
  ChatLauncherStyleType
} from "../../store/chatSetting/types";
import { generateId } from "../../store/util";

import StyleA from "./StyleA";
import StyleB from "./StyleB";
import StyleC from "./StyleC";

interface IProps {
  showChatBot: any;
  setToggle?: any;
  toggleCloseDialog: any;
}

export interface IChatBotLauncher {
  showChatBot: () => void
  toggleCloseDialog: () => void
  baseFontSize: number
  color: string
  query: string
  openText?: string
  guideTitleA?: string
  guideTitleB?: string
  guideTitleC?: string
  guideMessageA?: string
  guideMessageC?: string
  isMobile: boolean
}

const ChatBotLauncher: React.FC<IProps> = ({
  showChatBot,
  toggleCloseDialog
}) => {
  const chatSetting = useSelector((state: AppState) => state.chatSetting);
  const color = chatSetting.mainColor;
  const size = chatSetting.iconSize;
  const openText = chatSetting.openText;
  const guideTitleA = chatSetting.guideTitleA;
  const guideTitleB = chatSetting.guideTitleB;
  const guideTitleC = chatSetting.guideTitleC;
  const guideMessageA = chatSetting.guideMessageA;
  const guideMessageC = chatSetting.guideMessageC;

  const [query, setQuery] = useState(generateId());
  useEffect(() => {
    if (chatSetting.isSync) {
      setQuery(generateId());
    }
  }, [chatSetting.isSync]);

  const ua = navigator.userAgent;
  let isMobile = false;
  if (
    (ua.indexOf("iPhone") > 0 || ua.indexOf("Android") > 0) &&
    ua.indexOf("Mobile") > 0
  ) {
    isMobile = true;
  }

  const launcherStyleType = chatSetting.launcherStyleType;

  const getBaseFontSize = (size: ChatIconSize) => {
    switch (size) {
      case ChatIconSize.LARGE:
        return 14;
      case ChatIconSize.MEDIUM:
        return 12;
      case ChatIconSize.SMALL:
      default:
        return 10;
    }
  };
  let baseFontSize = getBaseFontSize(size);
  if (isMobile) {
    baseFontSize = getBaseFontSize(ChatIconSize.SMALL);
  }
  switch (launcherStyleType) {
    case ChatLauncherStyleType.StyleA:
      return (
        <StyleA
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          query={query}
          // launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
          openText={openText}
          guideTitleA={guideTitleA}
          guideMessageA={guideMessageA}
        />
      );
    case ChatLauncherStyleType.StyleB:
      return (
        <StyleB
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          query={query}
          // launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
          openText={openText}
          guideTitleB={guideTitleB}
        />
      );
    case ChatLauncherStyleType.StyleC:
      return (
        <StyleC
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          query={query}
          // launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
          openText={openText}
          guideTitleC={guideTitleC}
          guideMessageC={guideMessageC}
        />
      );
    default:
      return (
        <StyleA
          isMobile={isMobile}
          baseFontSize={baseFontSize}
          color={color}
          query={query}
          // launcherImageUrl={launcherImageUrl}
          showChatBot={showChatBot}
          toggleCloseDialog={toggleCloseDialog}
          openText={openText}
          guideTitleA={guideTitleA}
          guideMessageA={guideMessageA}
        />
      );
  }
};

export default ChatBotLauncher;
